###
# This directive can be used to perform validation on a form field which is
# required to be equal to another form field (for example, a confirm password
# field).
#
# compareTo: (object) the value to which to compare the input value.
#
# Example:
#   <input name="confirmPassword" compare-to="password">
###
angular.module('rjmNg.directives').directive "compareTo", [
  () ->
    require: "ngModel",
    restrict: "A"
    scope:
      compareTo: "="
    link: (scope, elements, attributes, model) ->

      validatorFn = (value) ->
        return true unless scope.compareTo?
        value is scope.compareTo

      model.$validators.compareTo = validatorFn

      scope.$watch "compareTo", () -> model.$validate

]
